import { useTranslation } from 'react-i18next';
import { MessageCirclePlus, MoreHorizontal, Search } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/dropdown/dropdown';
import { useAmboss } from './useAmboss';

export function AmbossHistoryView() {
  const { t } = useTranslation();
  const { historyGroups, rerun, deleteEntry } = useAmboss();

  const groupHeading = (key: string, label: string) => {
    if (key === 'today') return t('amboss.history.groups.today');
    if (key === 'last7Days') return t('amboss.history.groups.last7Days');
    return label;
  };

  if (historyGroups.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-card">
        <p className="text-sm text-muted-foreground">{t('amboss.history.empty')}</p>
      </div>
    );
  }

  return (
    <div className="h-full w-full overflow-y-auto bg-card p-4">
      {historyGroups.map((group) => (
        <section key={group.key} className="mb-6">
          <h2 className="mb-3 text-sm text-muted-foreground">
            {groupHeading(group.key, group.label)}
          </h2>
          <ul>
            {group.entries.map((entry) => (
              <li
                key={entry.id}
                className="-mx-2 flex items-center justify-between gap-2 rounded-md px-2 py-3 hover:bg-muted"
              >
                <button
                  className="flex min-w-0 flex-1 cursor-pointer items-center gap-2 text-left text-base text-foreground"
                  data-ph-no-autocapture
                  onClick={() => rerun(entry)}
                >
                  <span
                    className="shrink-0 text-muted-foreground"
                    aria-label={t(
                      `amboss.searchPanel.${entry.mode === 'ai' ? 'aiMode' : 'search'}`
                    )}
                  >
                    {entry.mode === 'ai' ? <MessageCirclePlus size={16} /> : <Search size={16} />}
                  </span>
                  <span className="truncate">{entry.query}</span>
                </button>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button
                      aria-label={t('amboss.history.entryMenu', { query: entry.query })}
                      data-ph-no-autocapture
                      className="shrink-0 cursor-pointer text-muted-foreground hover:text-foreground"
                    >
                      <MoreHorizontal size={18} />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => rerun(entry)}>
                      {t('amboss.history.rerun')}
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => deleteEntry(entry.id)}>
                      {t('amboss.history.delete')}
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
